export default "__VITE_ASSET__wFXRrRMP__"